import type { PodcastResult } from 'hooks/siteSearch/types';
import { BLOG } from 'lib/constants/routes';

import { ResultLayout } from '../layouts/ResultLayout';
import type { NavigationPayload } from '../SearchResults';

interface PodcastProps extends PodcastResult {
  onNavigate: ({ title, path }: NavigationPayload) => void;
}

export function Podcast({ slug, title, image, onNavigate }: PodcastProps) {
  const path = `${BLOG}/${slug}`;

  return (
    <ResultLayout
      href={path}
      title={title}
      image={image}
      type="Podcast"
      onNavigate={() => onNavigate({ title, path })}
    />
  );
}
